export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5003.0dbff811.jpg";